export const SadminDashApiUrls = {
  getSadminDashData: "dash/GetSadminDashData",
};

export default class SadminDashAPI {
  constructor(httpsClient, cache) {
    this.httpsClient = httpsClient;
    this.cache = cache;
  }

  async getSadminDashData(data, token) {
    return this.get(SadminDashApiUrls.getSadminDashData, data, token);
  }

  async get(url, data, token) {
    const response = await this.httpsClient.get(url, data, token);

    return response;
  }

  async post(url, data, token) {
    this.cache.remove("tests");

    await this.httpsClient.post(url, data, token);
  }
}
